<template>
  <el-container style="height: 100%">
    <el-header style="height: auto;">
      <el-form label-position="left" size="mini" inline :model="pageOptions" ref="followupFrom">
        <el-form-item label="类别:" prop="hospitalized">
          <el-select style="width: 80px" @change="typeChange" v-model="pageOptions.hospitalized" placeholder="请选择">
            <el-option
              v-for="type in types"
              :key="type.value"
              :label="type.label"
              :value="type.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组织:" prop="oids">
          <el-select style="width: 120px" v-model="pageOptions.oids" placeholder="请选择">
            <el-option
              v-for="org in orgList"
              :key="org.id"
              :label="org.name"
              :value="org.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="pageOptions.hospitalized === 1 ? '出院日期:' : '就诊日期:'">
          <el-date-picker
            style="width: 200px;"
            v-model="dateScope"
            :clearable="false"
            type="daterange"
            format="yyyy/MM/dd"
            value-format="timestamp"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            range-separator="~"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="主治医生:" prop="doctorName">
          <el-input class="header-input-name" placeholder="请输入" v-model="pageOptions.doctorName"></el-input>
        </el-form-item>
        <el-form-item label="诊断/术式:" prop="diagnoseOrOperating">
          <el-input class="header-input" placeholder="请输入" v-model="pageOptions.diagnoseOrOperating"></el-input>
        </el-form-item>
        <el-form-item label="病历号:" prop="historySn">
          <el-input class="header-input" placeholder="请输入" v-model="pageOptions.historySn"></el-input>
        </el-form-item>
        <el-form-item label="患者姓名:" prop="patName">
          <el-input class="header-input-name" placeholder="请输入" v-model="pageOptions.patName"></el-input>
        </el-form-item>
        <el-form-item label="年龄:">
          <el-input style="width: 60px" placeholder="最小" min="0" max = "150" maxlength="3" v-model="pageOptions.startAge"></el-input>
          <i style="padding: 0 5px">~</i>
          <el-input style="width: 60px" placeholder="最大" min="0" max = "150" maxlength="3" v-model="pageOptions.endAge"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="loadData">查找</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="clearParams" type="warning">清空</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="visibleAddFollowup = true" :disabled="selectRecords.length < 1">计划制定</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="exportRecord" type="success"><i class="fas fa-file-export" style="margin-right: 5px"></i>导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="$router.go(-1)" icon="el-icon-arrow-left" type="primary">返回</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main>
      <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="p20-scrollbar__view">
        <el-table
          v-loading="loading"
          :data="followupTable"
          ref="followupTableRef"
          border
          @selection-change="handleSelectionChange"
          style="width: 100%">
          <el-table-column
            type="index"
            align="center"
            width="40">
          </el-table-column>
          <el-table-column
            type="selection"
            align="center"
            width="45">
          </el-table-column>
          <el-table-column
            label="类别"
            align="center"
            width="50">
            <template slot-scope="scope">
              {{scope.row.hospitalized === 1 ? '住院' : '门诊'}}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="historySn"
            label="病历号"
            width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="patName"
            width="80"
            label="姓名">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sex"
            width="50"
            label="性别">
            <template slot-scope="scope">
              {{scope.row.sex === 1 ? '男' : '女'}}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="age"
            width="50"
            label="年龄">
          </el-table-column>
          <el-table-column
            align="center"
            prop="mobile"
            width="110"
            label="联系电话">
          </el-table-column>
          <el-table-column
            align="center"
            prop="orgName"
            width="80"
            label="就诊科室">
          </el-table-column>
          <el-table-column
            align="center"
            prop="admissionDate"
            width="95"
            column-key="admissionDate"
            :formatter="timeFormatter"
            label="入院日期">
          </el-table-column>
          <el-table-column
            column-key="leaveTime"
            prop="leaveTime"
            align="center"
            :formatter="timeFormatter"
            width="95"
            label="出院日期">
          </el-table-column>
          <el-table-column
            column-key="endDay"
            align="center"
            width="80"
            :formatter="timeFormatter"
            label="结束天数">
          </el-table-column>
          <el-table-column
            prop="attendingName"
            align="center"
            width="80"
            label="主治医生">
          </el-table-column>
          <el-table-column
            align="center"
            prop="operatingNames"
            label="术式">
          </el-table-column>
          <el-table-column
          prop="diagnoseNames"
          align="center"
          label="诊断">
          </el-table-column>
          <el-table-column
            width="80"
            align="center"
            label="操作">
            <template slot-scope="scope">
              <span style="cursor: pointer; color: #1890ff" @click="toRecord(scope.row)">查看病历</span>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </el-main>
    <el-footer style="height: auto">
      <el-pagination background
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="pagePagination.current"
                     :page-sizes="pagePagination.sizes"
                     :page-size="pagePagination.size"
                     :layout="pagePagination.layout"
                     :total="pagePagination.total">
      </el-pagination>
    </el-footer>
    <el-dialog title="定制随访计划" :visible.sync="visibleAddFollowup" :close-on-click-modal="false">
      <followup-list-edit
        ref="followupEditRef"
        :rids="recordIds"
        :show-buttons="false"
        @cancle="visibleAddFollowup = false"
        @saveDone="handleSaveFollowupDone"
      ></followup-list-edit>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visibleAddFollowup = false">取 消</el-button>
        <el-button type="primary" @click="$refs['followupEditRef'].save()">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import OrgService from '@/request/user/org'
import RecordService from '@/request/record/record'
import moment from 'moment'
import _ from 'lodash'
export default {
  name: "FollowupAdd",
  data () {
    return {
      orgList: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = moment().endOf('day').valueOf()
            const start = end - 3600 * 1000 * 24 * 7
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '本月',
          onClick (picker) {
            const end = moment().endOf('day').valueOf()
            const start = moment().startOf('month').valueOf()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = moment().endOf('day').valueOf()
            const start = end - 3600 * 1000 * 24 * 30
            picker.$emit('pick', [start, end])
          }
        }]
      },
      dateScope: [moment().subtract(1, 'day').startOf().valueOf(), moment().endOf('day').valueOf()],
      selectOrg: null,
      loading: false,
      types: [ /*{label: '全部', value: null},*/ {label: '门诊', value: 0}, {label: '住院', value: 1}],
      pageOptions: {
        oids: null,
        historySn: null,
        hospitalized: 0,
        diagnoseOrOperating: null,
        doctorName: null,
        patName: null,
        startAge: null,
        endAge: null,
        start: null,
        end: null,
        hasFollowup: 0
      },
      pagePagination: { current: 1, layout: "total, sizes, prev, pager, next, jumper", order: "DESC", size: 10, sizes: [10, 20, 30], sort: "createTime", total: 0 },
      followupTable: [],
      visibleAddFollowup: false,
      tempFollowupDiloagVisible: false,
      selectRecords: [],
      recordIds: null,
      timeout: null
    }
  },
  created () {
    this.loading = true
    let hid = this.$route.params.hid
    if (hid) {
      this.loadOrg(hid)
    }
  },
  methods: {
    loadOrg (hid) {
      if (hid) {
        OrgService.listOrg({pids: hid}).then(res => {
          if (res.result) {
            let _orgList = []
            let oids = []
            oids.push(hid)
            _.forEach(res.result, val => {
              if (val.otsn !== 'lx0001001002' && val.otsn !== 'lx0001001003') {
                oids.push(val.id)
                _orgList.push(val)
              }
            })
            this.pageOptions.oids = oids.toString()
            this.orgList = _.concat([{id: oids.toString(), name: '全部'}], _orgList)
            this.loadData()
          }
        })
      } else {
        console.log('error: ' + '建立随访计划没有获取到医院id')
      }
    },
    typeChange (value) {
      if (value === 1) {
        this.dateScope = [moment().subtract(7, 'day').startOf().valueOf(), moment().endOf('day').valueOf()]
      } else {
        this.dateScope = [moment().subtract(1, 'day').startOf().valueOf(), moment().endOf('day').valueOf()]
      }
    },
    loadData () {
      this.loading = true
      const _pageOptions = _.clone(this.pageOptions)
      const _pagePagination = _.clone(this.pagePagination)
      _pageOptions.start = moment(this.dateScope[0]).startOf('day').valueOf()
      _pageOptions.end = moment(this.dateScope[1]).endOf('day').valueOf()
      if (_pageOptions.hospitalized === 1) {
        _pageOptions.sectionName = 'leaveTime'
        _pagePagination.sort = 'leaveTime'
      } else {
        _pageOptions.sectionName = 'createTime'
        _pagePagination.sort = 'createTime'
      }
      RecordService.find(_pagePagination, _pageOptions).then(res => {
        if (res.result) {
          this.followupTable = res.result.content || []
          this.pagePagination.total = res.result.totalElements || 0
        }
      }).catch(error => {
        this.followupTable
        this.$message.error(error || '获取病历数据出错，请重试')
      }).finally(() => {
        this.loading = false
      })
    },
    // 清空搜索条件
    clearParams () {
      this.$nextTick(() => {
        const $from = this.$refs.followupFrom
        if ($from) {
          $from.resetFields()
          this.pageOptions.startAge = null
          this.pageOptions.endAge = null
          this.pageOptions.oids = this.orgList[0].id
          this.dateScope = [moment().subtract(1, 'day').startOf().valueOf(), moment().endOf('day').valueOf()]
          this.pagePagination.current = 1
          this.pagePagination.size = 10
          this.loadData()
        }
      })
    },
    exportRecord () {
      const _pageOptions = _.clone(this.pageOptions)
      _pageOptions.start = this.dateScope[0] || null
      _pageOptions.end = this.dateScope[1] || null
      if (_pageOptions.hospitalized === 1) {
        _pageOptions.sectionName = 'leaveTime'
        _pageOptions.sort = 'leaveTime'
      } else {
        _pageOptions.sectionName = 'createTime'
        _pageOptions.sort = 'createTime'
      }
      RecordService.export(_pageOptions)
    },
    handleSizeChange (pageSize) {
      this.pagePagination.size = pageSize
      this.pagePagination.current = 1
      this.loadData()
    },
    handleCurrentChange (pageOffset) {
      this.pagePagination.current = pageOffset
      this.loadData()
    },
    handleSelectionChange (selectRecords) {
      this.selectRecords = selectRecords || []
      const _ids = []
      _.forEach(this.selectRecords, val => {
        _ids.push(val.id)
      })
      this.recordIds = _ids.toString()
    },
    // 查看病历
    toRecord (record) {
      if (record.id) {
        this.$router.push({path: `/record/show/${record.id}`})
      }
    },
    handleSaveFollowupDone () {
      this.visibleAddFollowup = false
      this.loading = true
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.loadData()
      }, 500)
      this.loadData()
    },
    timeFormatter (row, column) {
      if (column.columnKey === 'admissionDate') {
        return  moment(row.admissionDate).format('YYYY-MM-DD')
      }
      if (column.columnKey === 'leaveTime') {
        if (!row.hospitalized) {
          return moment(row.admissionDate).format('YYYY-MM-DD')
        } else if (row.hospitalized === 1 && row.leaveTime) {
          return moment(row.leaveTime).format('YYYY-MM-DD')
        } else {
          return '未出院'
        }
      }
      if (column.columnKey === 'endDay') {
        let day = 0
        if (!row.hospitalized) {
          day = moment().startOf('day').diff(moment(row.admissionDate).startOf('day'), 'days')
        } else if (row.hospitalized === 1 && row.leaveTime) {
          day =  moment().startOf('day').diff(moment(row.leaveTime).startOf('day'), 'days')
        } else {
          day = '未出院'
        }
        return day
      }
    }
  }
}
</script>

<style scoped>
  .header-input {
    width: 100px;
  }
  .header-input-name {
    width: 80px;
  }
  .followup-list {
    min-height: 320px;
    max-height: 420px;
    padding: 10px 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
  }
</style>
